import {React, useState, useEffect, useRef} from "react";
import './style.scss';
import { image } from "../../Assets";
import Count from "../../Component/Count/Count";
import BookCall from "../../Component/BookCall/BookCall";
import CaseStudySlider from "../../Component/caseStudy/casestudy";

const CaseStudieslayout =(props)=>{

  const [openModal, setOpenModal] = useState(false);
  const modalRef = useRef(null);
    
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openModal && modalRef.current && !modalRef.current.contains(event.target)) {
        setOpenModal(false);
      }
    };

    const handleEsc = (event) => {
      if (event.key === "Escape") setOpenModal(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [ openModal]);
  
    return(
        <>
            <section className="banner-Visualisation" style={{backgroundImage:`linear-gradient(135deg, #15743880 0%, #15743880 100%), url(${props.banner})`,backgroundRepeat:'no-repeat',backgroundSize:'cover'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-12 tw-pb-20">
                            <h2>    
                                {props.name}
                            </h2>
                        </div>
                        <div className="col-lg-12 col-12">
                            <div className="d-flex tw-gap-10">
                                <div>
                                    <h4><b>Owner</b></h4>
                                    <p>{props.owner}</p>
                                </div>
                                <div>
                                    <h4><b>Location</b></h4>
                                    <p>{props.location}</p>
                                </div>
                                <div>
                                    <h4><b>Fractile Client</b></h4>
                                    <p>{props.fractileclient}</p>
                                </div>
                                <div>
                                    <h4><b>Value of Service</b></h4>
                                    <p>{props.valueofservice}</p>
                                </div>
                            </div>
                            <div className="d-flex tw-gap-10">
                                <div>
                                    <h4><b>Year</b></h4>
                                    <p>{props.year}</p>
                                </div>
                                <div>
                                    <h4><b>Contact</b></h4>
                                    <p>{props.contact}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="casestudy-section d2"> 
                <div className="container"> 
                    <div className="tw-pt-5 tw-pb-20 tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-10 tw-items-center"> 
                        <div className="lg:tw-col-span-6"> 
                            <p className="tw-text-black tw-mb-6"> 
                                {props.firstline}
                            </p> 
                        </div> 
                        <div className="lg:tw-col-span-6"> 
                            <img src={props.firstimg} alt="Case Study" className="tw-w-full lg:tw-w-[100%] lg:tw-ml-auto" /> 
                        </div> 
                    </div> 
                    <div className="tw-pb-20 tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-10 tw-items-center"> 
                        <div className="lg:tw-col-span-6"> 
                            <img src={props.secondimg} alt="Case Study" className="tw-w-full lg:tw-w-[100%] lg:tw-ml-auto" /> 
                        </div> 
                        <div className="lg:tw-col-span-6"> 
                            <p className="tw-text-black tw-mb-6"> 
                                {props.secondline}
                            </p> 
                        </div> 
                    </div> 
                </div> 
                <div className="container"> 
                    <div className="tw-pt-5 tw-pb-20 tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-10 tw-items-center"> 
                        <div className="lg:tw-col-span-6"> 
                            <p className="tw-text-black tw-mb-6"> 
                                {props.thirdline}
                            </p> 
                        </div> 
                        <div className="lg:tw-col-span-6"> 
                            <img src={props.thirdimg} alt="Case Study" className="tw-w-full lg:tw-w-[100%] lg:tw-ml-auto" /> 
                        </div> 
                    </div> 
                </div> 
            </section>
 
            
            {props.bottomimg ? 
                <section className="cs-bottom-bg" style={{background:`url(${props.bottomimg})`,backgroundSize:'cover'}}></section> 
                :
                <></>
            }

            <Count/>  

            {/* <CaseStudySlider/> */}

            <section>
                <div className="container tw-pt-10 md:tw-pt-15">
                    <div
                    className=" row tw-bg-[#157438] tw-text-white tw-p-[30px] md:tw-p-[60px] tw-my-[50px] tw-mx-auto tw-rounded-[30px] tw-flex tw-flex-wrap"
                    >
                    {/* Left Content */}
                    <div className="col-sm-9 col-12">
                        <h3 className="tw-text-[35px] tw-font-semibold tw-leading-tight tw-mb-4 max-md:tw-text-[24px]">
                            Lets Get Working
                        </h3>
                        <h5 className="tw-mb-2">At Fractile, you'll work on impactful projects, learn from seasoned leaders, and grow your technical craft. If you're committed to excellence, we're committed to you.</h5>
                    </div>

                    {/* Right Button */}
                    <div className="col-sm-3 col-12 tw-flex tw-items-end max-sm:tw-mt-6 md:tw-pt-0 tw-pt-5">
                        <button className="btn-2-white  tw-w-[80%] md-tw-w-[350px]"  onClick={() => setOpenModal(true)}>
                           Discuss Your Project
                        </button>
                    </div>
                    </div>
                </div>
            </section>

            <BookCall isOpen={openModal} onClose={() => setOpenModal(false)}/>    
        </>
    )
}

export default CaseStudieslayout;